/**
 * ScheduleDraft list query hook.
 * Design docs -> frontend/src/features/flightSchedule/ScheduleDraft/docs/20_workspace_ux/28_frontend_code_map_and_data_flow.md
 */

import { useQuery } from "react-query";
import { scheduleDraftQueryKeys } from "./queryKeys";
import { scheduleDraftDataService } from "../services/scheduleDraftDataService";

export function useScheduleDraftList(params, options = {}) {
    return useQuery(
        scheduleDraftQueryKeys.list(params),
        () => scheduleDraftDataService.getDraftList(params),
        {
            keepPreviousData: true,
            staleTime: 60000,
            refetchOnWindowFocus: false,
            ...options,
        },
    );
}

export default useScheduleDraftList;
